import module from 'fan/proyectos/module.js'
import template from './template.html'

export class FanProyectosAgregarConfirmarComponent {
  error
  data
  resultado = {exito: false}
  procesando = false
  onClose

  constructor ($state, FanProyectosService) {
    this.$state = $state
    this.FanProyectosService = FanProyectosService
  }

  aceptar () {
    if (!this.resultado.exito) return

    this.$state.go('proyecto.informacion', {id_proyecto: this.resultado.proyecto_id})
  }

  agregar () {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    this.FanProyectosService.post(this.data)
      .then((response) => {
        this.resultado.proyecto_id = response.data.proyecto_id
        this.resultado.exito = true
      })
      .catch((response) => {
        this.error = response.data
        this.procesando = false
      })
  }

  cerrar () {
    this.onClose()
  }
}

module.component('fanProyectosAgregarConfirmar', {
  controller: FanProyectosAgregarConfirmarComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyectos/components/agregar/confirmar/component.js